// import { machine } from '../../create-order-machine'
import { buildStateNode } from '../../build-state-node'

import { saveWro } from '@/models/createWarehouseReceivingOrder/commonActions/index'

import { CreateWarehouseReceivingOrderService } from '@/services/createWarehouseReceivingOrder/index'

import { mapShippingConfigurationsToApi, mapMultiSkuShippingConfigurationsToApi } from '@/mappers/receiving/draft/shippingConfiguration'
import {
  clearShippingConfigurationValues,
  validateShippingConfigurationValues,
  decidePath,
  clearMultiSkuShippingConfigurationValues,
  validateMultiSkuShippingConfigurations,
  autoFillSingleSKUFloorLoadedContainer,
  autoFillMultiSKUFloorLoadedContainer,
  checkIfConfigChanged
} from './actions'
// import { initializeShippingConfigurations } from '@/models/createWarehouseReceivingOrder/steps/addShippingConfigurations/actions'

const STEP_NAME = 'addShippingConfigurations'
const EDIT_NAME = STEP_NAME + '.' + 'pathDecider'

const stateNodeGenerator = buildStateNode({
  initial: 'pathDecider',
  states: {
    pathDecider: {
      onEntry: [decidePath],
      on: {
        IS_SINGLE_SKU: 'singleSku',
        IS_MULTI_SKU: 'multiSku',
        IS_MULTI_SKU_AUTO_FILL: 'multiSkuAutoFill',
        IS_SINGLE_SKU_AUTO_FILL: 'singleSkuAutoFill'
      }
    },
    multiSku: {
      initial: 'configurationsAdded',
      states: {
        empty: {
          onEntry: [clearMultiSkuShippingConfigurationValues],
          on: {
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty',
            ALL_QUANTITIES_ADDED: 'valid',
            INVALID_CONFIGURATION: 'configurationsAdded'
          }
        },
        configurationsAdded: {
          onEntry: [validateMultiSkuShippingConfigurations],
          on: {
            ALL_QUANTITIES_ADDED: 'valid',
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty',
            INVALID_CONFIGURATION: 'configurationsAdded'
          }
        },
        valid: {
          states: {
            saving: {
              on: {
                SAVE_FAIL: 'error'
              }
            },
            error: {}
          },
          on: {
            INVALID_CONFIGURATION: 'configurationsAdded',
            SAVE: {
              '.saving': {
                actions: [checkIfConfigChanged, saveWro({ mapper: mapMultiSkuShippingConfigurationsToApi, service: CreateWarehouseReceivingOrderService.updateMultiSkuShippingConfigurations })]
              }
            },
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty'
          }
        }
      }
    },
    singleSkuAutoFill: {
      initial: 'autofill',
      states: {
        autofill: {
          onEntry: [autoFillSingleSKUFloorLoadedContainer],
          on: {
            ALL_QUANTITIES_ADDED: 'valid'
          }
        },
        valid: {
          states: {
            saving: {
              on: {
                SAVE_FAIL: 'error'
              }
            },
            error: {}
          },
          on: {
            SAVE: {
              '.saving': {
                actions: [saveWro({ mapper: mapShippingConfigurationsToApi, service: CreateWarehouseReceivingOrderService.updateShippingConfigurations })]
              }
            }
          }
        }
      }
    },
    singleSku: {
      initial: 'configurationsAdded',
      states: {
        empty: {
          onEntry: [clearShippingConfigurationValues],
          on: {
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty',
            ALL_QUANTITIES_ADDED: 'valid',
            INVALID_CONFIGURATION: 'configurationsAdded'
          }
        },
        configurationsAdded: {
          onEntry: [validateShippingConfigurationValues],
          on: {
            ALL_QUANTITIES_ADDED: 'valid',
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty',
            INVALID_CONFIGURATION: 'configurationsAdded'
          }
        },
        valid: {
          states: {
            saving: {
              on: {
                SAVE_FAIL: 'error'
              }
            },
            error: {}
          },
          on: {
            INVALID_CONFIGURATION: 'configurationsAdded',
            SAVE: {
              '.saving': {
                actions: [checkIfConfigChanged, saveWro({ mapper: mapShippingConfigurationsToApi, service: CreateWarehouseReceivingOrderService.updateShippingConfigurations })]
              }
            },
            CLEAR: 'empty',
            EDIT_CLEAR: 'empty'
          }
        }
      }
    },
    multiSkuAutoFill: {
      initial: 'autofill',
      states: {
        autofill: {
          onEntry: [autoFillMultiSKUFloorLoadedContainer],
          on: {
            ALL_QUANTITIES_ADDED: 'valid'
          }
        },
        valid: {
          states: {
            saving: {
              on: {
                SAVE_FAIL: 'error'
              }
            },
            error: {}
          },
          on: {
            SAVE: {
              '.saving': {
                actions: [saveWro({ mapper: mapMultiSkuShippingConfigurationsToApi, service: CreateWarehouseReceivingOrderService.updateMultiSkuShippingConfigurations })]
              }
            }
          }
        }
      }
    }
  }
})

export const addShippingConfigurations = {
  name: STEP_NAME,
  editState: EDIT_NAME,
  stateNodeGenerator,
  history: false
}
